import { createSelector } from 'reselect';

const substate = (state) => state.policy;

export const selectPolicyValidationInfo = () => createSelector(substate, (contextState) => contextState.validationInfo);
